 // allow using the picker localization without loading the whole picker
 if (!$.calendarsPicker) $.calendarsPicker = {
       regionalOptions: {},
       setDefaults: $.noop
};